const productsOnPage = document.getElementById('product-grid');
const nextUrlElement = document.getElementById('paginateNext');
let nextUrl = nextUrlElement ? nextUrlElement.dataset.nextUrl : '';

const loadMoreBtn = document.querySelector('.load-more_btn');
const loadMoreText = loadMoreBtn.querySelector('[load-more-text]');
const loadMoreSpinner = loadMoreBtn.querySelector('[loader]');

async function getNextPage(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.text();
  } catch (error) {
    console.error('Error fetching next page:', error);
    return null;
  }
}

async function loadMoreProducts() {
  if (!nextUrl) {
    console.log("No more pages to load.");
    loadMoreBtn.style.display = 'none';
    return;
  }

  // Show spinner, hide text
  loadMoreText.style.display = 'none';
  loadMoreSpinner.classList.remove('hide');

  const nextPageHtml = await getNextPage(nextUrl);

  // Restore button state
  loadMoreText.style.display = 'inline';
  loadMoreSpinner.classList.add('hide');

  if (!nextPageHtml) {
    console.error("Failed to fetch next page.");
    return;
  }

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPageHtml, 'text/html');

  // Get new products
  const productGrid = nextPageDoc.getElementById('product-grid');
  const newProducts = productGrid ? Array.from(productGrid.getElementsByClassName('grid__item')) : [];

  if (newProducts.length > 0) {
    // Prevent duplicate products
    const existingProductIds = new Set(
      [...productsOnPage.getElementsByClassName('grid__item')].map(product => product.dataset.productId)
    );

    newProducts.forEach(product => {
      if (!existingProductIds.has(product.dataset.productId)) {
        productsOnPage.appendChild(product);
      }
    });
  }

  // Get and update the new next page URL
  const newNextUrlElement = nextPageDoc.getElementById('paginateNext');
  nextUrl = newNextUrlElement ? newNextUrlElement.dataset.nextUrl : '';

  if (!nextUrl) {
    loadMoreBtn.style.display = 'none'; // Hide button if no more pages
  }
}

// Attach event listener
loadMoreBtn.addEventListener('click', loadMoreProducts);
